import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=a2657f68&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=ts&"
export * from "./AddUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2657f68",
  null
  
)

export default component.exports